(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.controller('ExtraDayHolidayTableController', [
        'ItemTableService', 
        'DayschemeService', 
        'SharedAgendaService', 
        'Alert', 
        '$state', 
        '$stateParams', 
        'HelperService', 
        'DateService', 
        'AuthenticationService', 
        'RoleType',
        ExtraDayHolidayTableControllerFn]);

    /* controlle for main extra days and holidays table directive */
    function ExtraDayHolidayTableControllerFn(
        ItemTableService, 
        DayschemeService, 
        SharedAgendaService, 
        Alert, 
        $state, 
        $stateParams, 
        HelperService, 
        DateService, 
        AuthenticationService,
        RoleType) {

        var vm = this;

        // the service -> here the ItemTableService
        vm.overview = null;
        // chosen type - > readonly
        vm.readonly = false; //default extra day
        // ringfoon Super Admin 
        vm.isRingfoonAdmin = false;
        // selected country for import
        vm.selectedCountryId = null;
        //current year
        var currentYear = new Date().getFullYear();
        //list of selectable years
        vm.selectableYears = [currentYear, currentYear + 1, currentYear + 2, currentYear + 3];
        vm.selectedYears = [currentYear]; // current is always selected
        vm.selectedDate = null;
        vm.userId = null;

        activate();

      

        // import holidays
        vm.import = function (countryId) {
            // check
            if (vm.selectedCountryId !== null && vm.selectedYears.length > 0) {

                vm.selectedYears.sort(function (a, b) { return a - b; });

                var yearFrom = vm.selectedYears[0];
                var yearTo = vm.selectedYears[vm.selectedYears.length - 1];

                // import
                DayschemeService.importHolidays(vm.selectedCountryId, yearFrom, yearTo).then(function (result) {
                    Alert.success(result);
                    // reload
                    $state.reload($state.current, { all: vm.overview.data.showAll, readonly: vm.readonly }, { reload: $state.current });
                });
            } // if           
        };

        // funtion to select and deselect a country
        vm.select = function (countryId) {
            vm.selectedCountryId = vm.selectedCountryId === countryId ? null : countryId;
        };

        // toggle checkbox selections of years
        vm.toogleSelection = function (year) {
            if (vm.selectedYears.indexOf(year) === -1) {
                vm.selectedYears.push(year);
            } // if
            else {
                vm.selectedYears.splice(vm.selectedYears.indexOf(year), 1);
            } // else
        };

        // show only active or all items 
        vm.showAll = function () {
            $state.go($state.current.name, { all: vm.overview.data.showAll, readonly: vm.readonly }, { reload: $state.current.name });
        };

        // add created dayschemes to list
        vm.daySchemeAdded = function (result) {
            App.unblockUI();
            // add to list (get array)
            for (var i = 0; i < result.length; i++) {
                vm.overview.put(result[i]);
            } //for

            // reorder 
            // Important: here whe use built-it sort-function 
            // not very fast, but inserting is not done very often -> 
            // if slow -> use binary search for inserting in sorted-array
            vm.overview.sort();
        };

        // sort by date
        function orderBy(a, b) {
            return HelperService.date(a.date) - HelperService.date(b.date); // ascending
        } // orderBy


        /* activation work */
        function activate() {

            // only superadmin is allow to delete global holidays
            vm.isRingfoonAdmin = AuthenticationService.isInRole(RoleType.RingfoonAdmin);        

            vm.selectedDate = DateService.data.date;
            vm.userId = SharedAgendaService.currentUser().id;

            // countries
            vm.countries = HelperService.data.countriesWithCallingCodes;

            // sort by date
            vm.days.sort(orderBy);

            // init translation list
            ItemTableService.init(vm.days);
            // put sort function to table
            ItemTableService.data.sortFn = orderBy;

            // type
            vm.readonly = $stateParams.readonly;

            //service
            vm.overview = ItemTableService;
        } // activate
    }
})();
